export default __webpack_public_path__ + "static/un-4c0a34afb0c02cd13b3df7aa133bed62.svg";